import React, {Component} from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

import Button from '@material-ui/core/Button'

import withStyles from '@material-ui/core/styles/withStyles'

const styles = theme => ({

})

/**
 * <DeleteFolderDialog folder onDeleteFolder = {folder} onCancel = {} />
 */

class DeleteFolderDialog extends Component {

	render() {
		return <Dialog
			open = {true}
			scroll = "body"
		>
			<DialogTitle>
				Удалить папку
			</DialogTitle>
			<DialogContent style = {{display: "flex", flexDirection: "column"}}>
				Вы уверены, что хотите удалить папку &laquo;{this.props.folder.name}&raquo; и все ее содержимое?
			</DialogContent>
			<DialogActions>
				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onDeleteFolder === "function") {
							this.props.onDeleteFolder(this.props.folder)
						}
					}}
				>Удалить</Button>
				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCancel === "function") {
							this.props.onCancel()
						}
					}}
				>Отмена</Button>
			</DialogActions>
		</Dialog>

	}

}

export default withStyles(styles)(DeleteFolderDialog)
